document.addEventListener("DOMContentLoaded", () => {
    const article_image_banner = document.querySelector("#articleBannerImage");
    const article_banner_section = document.getElementById("articleBannerSection");

    if (article_image_banner && article_banner_section) {
     
        const checkImageStatus = () => {
            const isImageBroken = !article_image_banner.complete || article_image_banner.naturalWidth === 0;    
            if (isImageBroken) {
                article_banner_section.classList.remove("tw-mt-[-192px]");

            } 
        };
        if (article_image_banner.complete) {
            checkImageStatus();
        } else {
            article_image_banner.addEventListener("load", () => {
                checkImageStatus();
            });
            article_image_banner.addEventListener("error", () => {
                article_banner_section.classList.remove("tw-mt-[-192px]");
            });
        }
    }
});